import { classnames } from '@aibees/shared/utils';
import { SelectProps } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { NumberSingleSelectProps as Props } from './types';

export const NumberSingleSelect = memo(
  ({ className, children, label, placeholder, value, ...props }: Props) => {
    const MenuProps: SelectProps['MenuProps'] = {
      PaperProps: {
        sx: SX.paperProps,
      },

      MenuListProps: {
        sx: SX.menuListProps,
      },
      PopoverClasses: {},
      classes: {},
    };

    return (
      <Styled.Wrapper variant="outlined" fullWidth size="small">
        <Styled.InputLabel shrink size="small" id={label?.toString()}>
          {label}
        </Styled.InputLabel>
        <Styled.Select
          key={value || '1' + label}
          labelId={label?.toString()}
          id={`select-${label}`}
          className={classnames('NumberSingleSelect', className)}
          sx={SX.root}
          value={value}
          size="small"
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              return placeholder;
            }

            return selected;
          }}
          MenuProps={MenuProps}
          variant="outlined"
          inputProps={{ sx: SX.inputProps }}
          {...props}
        >
          {children}
        </Styled.Select>
      </Styled.Wrapper>
    );
  }
);

NumberSingleSelect.displayName = 'NumberSingleSelect';
